import React from "react"

export function Advantages(): React.JSX.Element {
    return (
        <section id="advantages">
        <div
            style={{
                fontFamily: "system-ui, -apple-system, sans-serif",
                padding: "40px 20px",
            }}
        >
            <div
                style={{
                    backgroundColor: "#19191F",
                    borderRadius: "10px",
                    maxWidth: "1400px",
                    margin: "0 auto",
                    padding: "clamp(40px, 5vw, 60px) clamp(20px, 4vw, 40px)",
                }}
            >
                {/* Header Section */}
                <div
                    style={{
                        textAlign: "center",
                        marginBottom: "clamp(40px, 8vw, 60px)",
                    }}
                >
                    <div
                        style={{
                            fontSize: "clamp(12px, 2vw, 14px)",
                            color: "#F485C7",
                            fontWeight: "500",
                            marginBottom: "16px",
                            letterSpacing: "0.5px",
                        }}
                    >
                        Advantages
                    </div>
                    <h2
                        style={{
                            fontSize: "clamp(24px, 4vw, 32px)",
                            fontWeight: "600",
                            color: "#fff",
                            marginBottom: "16px",
                            letterSpacing: "-0.5px",
                            lineHeight: "1.2",
                        }}
                    >
                        En sensor för dina behov
                    </h2>
                    <p
                        style={{
                            fontSize: "clamp(14px, 2.5vw, 16px)",
                            color: "#999",
                            lineHeight: "1.6",
                            maxWidth: "500px",
                            margin: "0 auto",
                        }}
                    >
                        We build sensors for your company, where you can track patch and update whenever hover you want
                    </p>
                </div>

                {/* Stats Cards */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: "clamp(20px, 4vw, 40px)",
                        marginTop: "40px",
                    }}
                >
                    {/* Card 1 */}
                    <div
                        style={{
                            backgroundColor: "#22222A",
                            borderRadius: "12px",
                            textAlign: "center",
                            padding: "clamp(24px, 4vw, 32px) clamp(16px, 3vw, 24px)",
                        }}
                    >
                        <div
                            style={{
                                width: "clamp(48px, 8vw, 64px)",
                                height: "clamp(48px, 8vw, 64px)",
                                backgroundColor: "#F485C7",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 24px auto",
                            }}
                        >
                            {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#2a2a30" />
                            </svg>
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(24px, 5vw, 32px)",
                                fontWeight: "700",
                                color: "#fff",
                                marginBottom: "8px",
                            }}
                        >
                            10 000 +
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(12px, 2.5vw, 14px)",
                                color: "#F485C7",
                                fontWeight: "500",
                                marginBottom: "16px",
                            }}
                        >
                            Sålda enheter
                        </div>
                        <p
                            style={{
                                fontSize: "clamp(12px, 2.2vw, 14px)",
                                color: "#999",
                                lineHeight: "1.5",
                                margin: 0,
                            }}
                        >
                            Utforska sensorns som faktiskt gör skillnad, många sålda enheter många nöjda kunder
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div
                        style={{
                            backgroundColor: "#22222A",
                            borderRadius: "12px",
                            textAlign: "center",
                            padding: "clamp(24px, 4vw, 32px) clamp(16px, 3vw, 24px)",
                        }}
                    >
                        <div
                            style={{
                                width: "clamp(48px, 8vw, 64px)",
                                height: "clamp(48px, 8vw, 64px)",
                                backgroundColor: "#F485C7",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 24px auto",
                            }}
                        >
                            {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="12" cy="12" r="3" fill="#2a2a30" />
                                <path
                                    d="M12 1v6m0 10v6m11-7h-6m-10 0H1m15.5-6.5l-4.24 4.24m-8.48 0L7.5 5.5m12.73 12.73l-4.24-4.24m-8.48 0l4.24 4.24"
                                    stroke="#2a2a30"
                                    strokeWidth="2"
                                />
                            </svg>
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(24px, 5vw, 32px)",
                                fontWeight: "700",
                                color: "#fff",
                                marginBottom: "8px",
                            }}
                        >
                            10 000 +
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(12px, 2.5vw, 14px)",
                                color: "#F485C7",
                                fontWeight: "500",
                                marginBottom: "16px",
                            }}
                        >
                            Sålda enheter
                        </div>
                        <p
                            style={{
                                fontSize: "clamp(12px, 2.2vw, 14px)",
                                color: "#999",
                                lineHeight: "1.5",
                                margin: 0,
                            }}
                        >
                            Utforska sensorns som faktiskt gör skillnad, många sålda enheter många nöjda kunder
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div
                        style={{
                            backgroundColor: "#22222A",
                            borderRadius: "12px",
                            textAlign: "center",
                            padding: "clamp(24px, 4vw, 32px) clamp(16px, 3vw, 24px)",
                        }}
                    >
                        <div
                            style={{
                                width: "clamp(48px, 8vw, 64px)",
                                height: "clamp(48px, 8vw, 64px)",
                                backgroundColor: "#F485C7",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 24px auto",
                            }}
                        >
                            {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 14l3-3 3 3 5-5"
                                    stroke="#2a2a30"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M21 7v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h14a2 2 0 012 2z"
                                    stroke="#2a2a30"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(24px, 5vw, 32px)",
                                fontWeight: "700",
                                color: "#fff",
                                marginBottom: "8px",
                            }}
                        >
                            10 000 +
                        </div>
                        <div
                            style={{
                                fontSize: "clamp(12px, 2.5vw, 14px)",
                                color: "#F485C7",
                                fontWeight: "500",
                                marginBottom: "16px",
                            }}
                        >
                            Sålda enheter
                        </div>
                        <p
                            style={{
                                fontSize: "clamp(12px, 2.2vw, 14px)",
                                color: "#999",
                                lineHeight: "1.5",
                                margin: 0,
                            }}
                        >
                            Utforska sensorns som faktiskt gör skillnad, många sålda enheter många nöjda kunder
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </section>
    )
}